export const GET_MOVIE_LIST = "GET_MOVIE_LIST";
export const GET_MOVIE_LIST_SUCCESS = "GET_MOVIE_LIST_SUCCESS";
export const GET_SERIES_LIST = "GET_SERIES_LIST";
export const GET_SERIES_LIST_SUCCESS = "GET_SERIES_LIST_SUCCESS";